<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <template v-if="active">
      <circle cx="21" cy="21" r="15.91549430918954" :style="{ fill: 'var(--color-primary-500, #00A624)' }"/>
      <circle class="donut-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent" :style="{ stroke: 'var(--color-primary-500, #00B52D)' }" stroke-opacity="24%" stroke-width="4"/>
      <circle cx="21" cy="21" r="6" fill="#fff"/>
    </template>
    <template v-else>
      <rect x="1" y="1" width="38" height="38" rx="19" fill="#fff" stroke="#98A2B3" stroke-width="2"/>
      <circle cx="20" cy="20" r="6" fill="#475467"/>
    </template>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'step-icon',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
});
</script>